import { render } from "./CV.vue?vue&type=template&id=281a576a&scoped=true"
const script = {}

import "./CV.vue?vue&type=style&index=0&id=281a576a&scoped=true&lang=css"

import exportComponent from "/Users/hk/Omat tiedostot/koodit/htmljacss/hkvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281a576a"]])

export default __exports__